import { useUrlSearch } from '@/search';

export default () => {
  const urlSearch = useUrlSearch();
  const currentPage = Number(urlSearch.getValue('page')) || 1;

  const onPageClick = (page) => {
    if (page === currentPage) return;

    const params = urlSearch.getParams();

    params.set('page', page);
    urlSearch.applyParams(params);
  };

  return { currentPage, onPageClick };
};
